import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateStudyAreaRoutingModule } from './create-study-area-routing.module';
import { TableModule } from 'primeng/table';
import { AddStudyAreaNameModalComponent } from '../shared/components/add-study-area-name-modal/add-study-area-name-modal.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [
    AddStudyAreaNameModalComponent
  ],
  imports: [
    CommonModule,
    CreateStudyAreaRoutingModule,
    TableModule,
    FormlyModule.forChild(),
    FormlyPrimeNGModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule
  ],
})
export class CreateStudyAreaModule { }
